<div class="filter-bar-container" [formGroup]="filterForm">

  <mat-form-field appearance="outline" class="filter-select">
    <mat-label>{{ statsMode === 'ia' ? 'Temporada (opcional)' : 'Temporada' }}</mat-label>
    <mat-select formControlName="seasonId">
      <mat-option *ngFor="let season of (filters$ | async)?.seasons" [value]="season.id">
        {{ season.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline" class="filter-select wide-select">
    <mat-label>Competiciones</mat-label>
    <mat-select formControlName="competitionIds" multiple>
      <mat-option *ngFor="let comp of (filters$ | async)?.competitions" [value]="comp.id">
        {{ comp.name }}
      </mat-option>
    </mat-select>

    <button
      mat-icon-button
      matSuffix
      type="button"
      *ngIf="filterForm.get('competitionIds')?.value?.length"
      (click)="clearCompetitions($event)"
      aria-label="Limpiar competiciones">
      <mat-icon>close</mat-icon>
    </button>

  </mat-form-field>

  <mat-form-field appearance="outline" class="filter-select">
    <mat-label>Género</mat-label>
    <mat-select formControlName="gender">
      <mat-option [value]="null">Todos</mat-option>
      <mat-option *ngFor="let gender of (filters$ | async)?.genders" [value]="gender.id">
        {{ gender.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline" class="filter-text-search">
    <mat-label>Buscar por nombre...</mat-label>
    <input matInput formControlName="textSearch" placeholder="Ej: Real Madrid">
    <mat-icon matSuffix *ngIf="filterForm.get('textSearch')?.value" (click)="clearTextSearch()" class="clear-icon">
      close
    </mat-icon>
  </mat-form-field>

  <button
    mat-stroked-button
    class="clear-button"
    (click)="clearAllFilters()">
    <mat-icon>clear_all</mat-icon>
    Limpiar
  </button>

</div>
